import styled from 'styled-components'

export const FiltersWrapper = styled.div`
  column-gap: var(--spacer-2);
  row-gap: var(--spacer-2);
`

FiltersWrapper.displayName = 'FiltersWrapper'

export const Filter = styled.button`
  background-color: transparent !important;
  border: 1px solid var(--gray-200);
  border-radius: var(--spacer-8);
  padding: 0 var(--spacer-4);
  height: 2.625rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background 0.26s ease-in-out;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background-color: var(--gray-300);
  }

  &:focus {
    outline: 2px solid var(--blue);
    outline-offset: -2px;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

Filter.displayName = 'Filter'
